import { getCountry, getManualByCountry } from '../utils';

const country = getCountry();
const docHost = `http://help.refactory.neogig.com.${country}`;
const linkManual = getManualByCountry(country, docHost);

export const env = {
  NODE_ENV: 'development',
  NEOGIG_CLIENT_ID: 'neogig_qa',
  NEODASH_CLIENT_ID: 'neodash_qa',
  MAPBOX_KEY: `pk.eyJ1IjoibmVvY29tc2VydmljZSIsImEiOiJjbWRodGl3ZjkwNWd5MmpxMXMzM2RubWlxIn0.cVfKHNfwS3HgtJn4rj1vPg`,
  CARTO_KEY: 'cb1_28bg_1_0356ced9998003b244e01e82',
  URL: {
    NEOGIG_HOST: `http://refactory.neogig.com.${country}`,
    NEODASH_HOST: `http://neodash.refactory.neogig.com.${country}`,
    API_HOST: `http://neogig-api.refactory.neogig.com.${country}/api/v1`,
    MANUAL_URL: linkManual,
    IDENTITY_SERVER_URL: `http://identity-server.refactory.neogig.com.${country}`,
    CTRL_PANEL_API: `http://cp-api.refactory.neogig.com.${country}`,
  }
};



// WEBPACK FOOTER //
// ./src/config/refactory.env.js